import { Component } from '@angular/core';
import validationEngine from 'devextreme/ui/validation_engine';
import { DevExtremeModule } from 'devextreme-angular';
import * as _ from 'lodash';
import { CdrUnitOfWork } from 'src/app/core/core.module';
import { TimeType } from 'src/app/core/model/time-type';
import { TonExpense } from 'src/app/core/model/ton-expense';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-ton-expense-dialog',
    templateUrl: './ton-expense-dialog.component.html',
    styleUrls: ['./ton-expense-dialog.component.scss'],
    standalone: true,
    imports: [DevExtremeModule]
})
export class TonExpenseDialogComponent extends BaseDialogComponent<any> {
    tonExpense: TonExpense;

    constructor(private uow: CdrUnitOfWork) {
        super();
    }

    async ngOnInit() {
        if (!this.tonExpense) this.tonExpense = this.uow.tonExpenses.createEntity();
    }

    save = async () => {
        const success = this.valid();
        if (!success) return;

        await this.uow.commit();
        this.hide({ success: true, value: this.tonExpense });
    };

    cancel = async () => {
        this.uow.rollback();
        this.hide({ success: false });
    };

    valid() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            return result.isValid;
        } else return false;
    }
}
